/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React from 'react';

import './ProgressBar.scss';

type ProgressBarProps = {
    percentage: number | undefined | null;
};

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage }) => {
    if (percentage === undefined || percentage === null || percentage <= 0) {
        return null;
    }
    const isComplete = percentage > 95;
    return (
        <div className={`progress-bar ${isComplete ? 'complete' : 'incomplete'}`}>
            {!isComplete && <span className="indicator" style={{ marginLeft: `${percentage}%` }} />}
        </div>
    );
};

export default ProgressBar;
